<template>
  <el-select v-model="value" :name="content" :loading-text="loadingText" :no-match-text="emptyText"
    :no-data-text="emptyText" multiple collapse-tags filterable remote reserve-keyword id="localsationBien"
    class="critere mb-2 mb-xl-0 order-3 order-sm-4" placeholder="Ville ou quartier" :remote-method="remoteMethod"
    @change="select" :loading="loading">
    <el-option-group v-for="(group, idx) in options" :key="idx" :label="group.label">
      <el-option v-for="(item, idx) in group.options" :key="idx" :label="item.label"
        :value="{ value: item.value, label: item.label }">
        {{ item.label }}
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import Vue from 'vue'
import Select from 'element-ui'
import toulouseQuartiers from '../assets/toulouse.json'

Vue.use(Select)

const API_URL = 'https://geo.api.gouv.fr/communes?nom=:query&fields=nom,code,centre&boost=population&limit=5'
// const ApiUrlCommune = 'https://geo.api.gouv.fr/communes?nom=:query&fields=centre,codesPostaux&boost=population&limit=1'

export default {
  data() {
    return {
      options: [],
      value: [],
      list: [],
      query: '',
      content: '',
      listQuartiers: toulouseQuartiers,
      loading: false,
      loadingText: 'Chargement',
      emptyText: 'Aucune ville ou quartier correspondant'
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.query = query
        this.loading = true
        const arraySelections = []
        if (this.value.length > 0) {
          this.value.forEach(function (item) {
            arraySelections.push({ value: item.value, label: item.label })
          })
        }
        const arrayQuartiers = []
        this.listQuartiers.filter(item => {
          if (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1) {
            arrayQuartiers.push({ value: item.value, label: item.label })
          }
        })
        const arrayVilles = []
        fetch(API_URL.replace(':query', query))
          .then((response) => {
            response.json()
              .then((result) => {
                const geoCodeAdresses = result
                Object.entries(geoCodeAdresses).forEach(([index, value]) => {
                  arrayVilles.push({ value: value.centre.coordinates[1] + '@' + value.centre.coordinates[0], label: value.nom })
                })
                const list = [
                  {
                    label: 'Sélection',
                    options: arraySelections
                  },
                  {
                    label: 'Ville',
                    options: arrayVilles
                  }
                ]
                if (arrayQuartiers.length > 0) {
                  list[2] = {
                    label: 'Quartier',
                    options: arrayQuartiers
                  }
                }
                this.options = list
                this.loading = false
              })
          })
      } else {
        this.options = []
      }
    },
    select(values) {
      this.remoteMethod(this.query)
      let toSend = ''
      let cityNames = ''
      for (let city of values) {
        if (toSend === '') {
          toSend = city.value
        } else {
          toSend = toSend + ';' + city.value
        }
        if (cityNames === '') {
          cityNames = city.label
        } else {
          cityNames = cityNames + ';' + city.label
        }
      }
      this.$emit('changedGPSData', toSend, cityNames)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  content: '\2713';
}

.el-icon-close {
  right: 0 !important;
}

.el-icon-close:before {
  content: '\2716';
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: var(--color-primary);
  max-width: 99%;
  display: flex !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-select {
  height: 2.5rem !important;

  .el-tag {
    margin: 0 auto !important;
  }

  .el-select__tags {
    display: flex !important;
    flex-direction: row !important;
    height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;

    span {
      padding: 0.2rem 0 !important;
      width: 60% !important;
      height: 100% !important;
      display: flex !important;
      flex-direction: row !important;

      span {
        margin: auto 0 auto 0.25rem !important;
      }

      >span:first-of-type {
        width: 100% !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      >span:nth-of-type(2) {
        max-width: 2.4rem;
      }
    }
  }

  .el-select__input {
    margin-left: 0.5rem !important;
  }

  .el-input__suffix {
    display: none !important;
  }

  .el-input {
    height: 2.5rem !important;
    width: 100% !important;
  }

  .el-input__inner {
    padding-right: 0 !important;
    padding-left: 0.5rem !important;
    height: 100% !important;
    border-radius: 0 !important;
  }
}

@media (max-width: 575px) {
  #barreRechercheBien {
    .el-select {
      width: 70% !important;
      max-width: 12rem !important;
    }
  }
}

@media (min-width: 576px) and (max-width: 991px) {
  #barreRechercheBien {
    .el-select {
      width: 33.33% !important;
    }
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  #barreRechercheBien {
    .el-select {
      width: calc(33.33% - 8rem) !important;
    }
  }
}

@media (min-width: 1200px) {
  #barreRechercheBien {
    .el-select {
      width: 15% !important;
    }
  }
}
</style>
